import $ from 'jquery'
import Backbone from 'backbone'
import _ from 'lodash'
import AdminTwoColumnEditor from '../../admin-two-column-editor'
import appDisplay from 'scoreboard/components/app-display'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import i18n from 'scoreboard/components/i18n'
import User from './user'
import UserList from './user-list'
import UserForm from './user-form'
import ImportUsersWizard from './import/import-users-wizard'
import user from 'scoreboard/components/user'
import permissions from 'scoreboard/components/permissions'
import dependencyConfirmationPrompt from 'scoreboard/components/edit/dependency-confirmation-prompt'

// see AdminTwoColumnEditor for more documentation on things attached to 'this'
var AdminUsers = AdminTwoColumnEditor.extend({

	urlRoot: 'admin/users',
	Model: User,
	SelectorView: UserList,
	DisplayView: UserForm,
	ImportWizard: ImportUsersWizard,
	heading: 'common.user.users',

	className: AdminTwoColumnEditor.prototype.className + ' admin-users',

	loadItemOptions: {
		groups: true
	},

	render: function() {
		AdminTwoColumnEditor.prototype.render.apply(this, arguments)
		this.on('error', this.onError.bind(this))
	},

	renderSelectedItem: function(model) {
		AdminTwoColumnEditor.prototype.renderSelectedItem.apply(this, arguments)
		var canEdit = model.isNew()
			|| model.get('editable')
			|| model.get('groupEditable')
			|| (user.equals(model) && permissions.personalAccountInfo())
		var canDelete = model.get('deletable')
		this.$('.sticky-footer').toggleClass('is-not-displayed', !canEdit)
		this.$('.sticky-footer .delete').toggleClass('is-not-displayed', !canDelete)
	},

	'delete': function() {
		const url = `api/admin/users/${this.item.id}/delete-dependencies`
		appDisplay.dialog($.get(url), list => {
			if (_.isEmpty(list)) { // Normal Delete, no dependencies
				// #8972 don't clobber the title of the delete dialog
				var options = _.omit(this.item.attributes, 'title')
				const confirmation = new DeleteConfirmation(options)
				confirmation.once('confirm', item => {
					this.item.destroy({
						success: () => {
							Backbone.trigger('delete:domain-object', this.item)
							this.$('.edit-buttons').addClass('is-not-displayed')
							confirmation.trigger('done')
						}
					})
				})
				return confirmation
			} else { // Hard Confirm, there are dependencies (scheduled exports)
				const label = this.item.get('label')
				const confirmation = dependencyConfirmationPrompt
					.confirmationView(this.item, {
						list,
						messagePrefix: i18n.get('common.user.delete.confirm', label)
					})
				confirmation.once('done', () => {
					this.$('.edit-buttons').addClass('is-not-displayed')
					Backbone.trigger('delete:domain-object', this.item)
				})
				return confirmation
			}
		})
	},

	onError: function(model, xhr) {
		model.set(_.pick(this.originalItem.attributes, 'memberGroups', 'adminGroups'), {silent: true})
		this.renderSelectedItem(model)
	}

})

export default AdminUsers

AdminUsers.__filename__ = 'admin/principals/users/admin-users.js'
